module.exports = __webpack_public_path__ + "img/img09.f753cbcd.jpg";